import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { ReportsState, getCache, getCacheLoaded } from '../store';
import { paths } from "../report-paths";
import { map, take, filter, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ReportTypeGuard  {

    constructor(
        private store: Store<ReportsState>,
        private router: Router
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const cacheKey = next.paramMap.get('cacheKey');

        if (next.queryParams.hs)
            return this.router.parseUrl(`/${cacheKey}/other?hs_=1`);

        if (next.children.length) {
            return true;
        }
        
        if(next.url.length > 1) {
            return true;
        }
        console.log('Redirecting');
        
        return this.cacheLoaded().pipe(
            switchMap(() => this.store.pipe(
                select(getCache),
                take(1),
                map(rCache => {
                    const subPath: string = paths[rCache.report_type][0].path;
                    const path: string = `/${cacheKey}/${subPath}`;
                    return this.router.parseUrl(path);
                })
            ))
        )
    }

    canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean {
        const cacheKey = next.paramMap.get('cacheKey');
        const routePath: string = next.url[0]?.path;
        if (!routePath)
          return true;

        return this.store.pipe(
            select(getCache),
            map(rCache => {
                let included: boolean = false;
                const links = paths[rCache.report_type];
                for (let index = 0; index < links.length; index++) {
                    included = links[index].path === routePath;
                    if (included) {
                        break;
                    }
                }
                return included || this.router.parseUrl(`/${cacheKey}/other`);
            })
        );
    }

    cacheLoaded(): Observable<boolean> {
        return this.store.pipe(
            select(getCacheLoaded),
            filter(loaded => loaded),
            take(1)
        );
    }

}
